<template>
    <div>
        <MsgHeader ref='msg' @msg-click="handleMsg" />
        <div class="form-box mb10" v-loading="loading">
            <el-form inline :model="formData" size="mini" ref="formInline">
                <el-form-item prop="work_order" v-if="getCustomFilterShow('work_order')">
                    <CustomInput label='工单' @append-click="handleGenAppendClick('work_order', '输入或粘贴工单ID，每行一个')">
                        <template #prepend>
                            <el-select style="width:80px" v-model="formData.work_order_type" slot="prepend"
                                placeholder="请选择" class="customInput_prepend_select">
                                <el-option value="1" label="工单选择"></el-option>
                                <el-option value="2" label="工单搜索"></el-option>
                            </el-select>
                        </template>
                        <ESelect v-if="formData.work_order_type == '1'" v-model="formData.work_order" filterable
                            clearable placeholder="请输入工单名称、ID搜索" multiple collapse-tags remote reserve-keyword
                            :loading="searchLoading" ref="work_order"
                            @visible-change="(val) => handleVisibleChange(val, 'work_order')"
                            :remote-method="(search) => appEntrySearchList(search, 'work_order')">
                            <p class="option-select">
                                <el-button type="text"
                                    @click="() => handleSelectAll(work_order_DataList, 'work_order', 'all')">全选</el-button>
                                <el-button type="text"
                                    @click="() => handleSelectAll(work_order_DataList, 'work_order', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option v-for="item in work_order_DataList" :key="item.value" :label="item.label"
                                :value="item.value" />
                        </ESelect>
                        <el-input v-model="formData.work_order_search" placeholder="请输入工单名称、ID搜索" clearable
                            style="width:180px" v-if="formData.work_order_type == '2'"></el-input>
                        <template #append v-if="formData.work_order_type == '1'">
                            <i class="el-icon-document-copy" />
                        </template>
                        <template #appendOrther>
                            <div :style="{ color: 'red', display: 'inline-block' }">
                                <i class="el-icon-close" @click="handleDel('work_order')" />
                            </div>
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="company_name" v-if="getCustomFilterShow('company_name')">
                    <CustomInput label='客户名称' @append-click="handleGenAppendClick('company_name', '输入或粘贴客户名称，每行一个')">
                        <ESelect v-model="formData.company_name" filterable
                                   clearable placeholder="请输入客户名称搜索选择" multiple collapse-tags remote reserve-keyword
                                   :loading="searchLoading" ref="company_name"
                                   @visible-change="(val) => handleVisibleChange(val, 'company_name')"
                                   :remote-method="(search) => appEntrySearchList(search, 'company_name')">
                            <p class="option-select">
                                <el-button type="text"
                                           @click="() => handleSelectAll(company_name_DataList, 'company_name', 'all')">全选</el-button>
                                <el-button type="text"
                                           @click="() => handleSelectAll(company_name_DataList, 'company_name', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option v-for="item in company_name_DataList" :key="item.value" :label="item.label"
                                       :value="item.value" />
                        </ESelect>
                        <template #append>
                            <i class="el-icon-document-copy" />
                        </template>
                        <template #appendOrther>
                            <div :style="{ color: 'red', display: 'inline-block' }">
                                <i class="el-icon-close" @click="handleDel('company_name')" />
                            </div>
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="bloc_name" v-if="getCustomFilterShow('bloc_name')">
                    <CustomInput label='集团名称' @append-click="handleGenAppendClick('bloc_name', '输入或粘贴集团名称，每行一个')">
                        <ESelect v-model="formData.bloc_name" filterable
                                   clearable placeholder="请输入集团名称搜索选择" multiple collapse-tags remote reserve-keyword
                                   :loading="searchLoading" ref="bloc_name"
                                   @visible-change="(val) => handleVisibleChange(val, 'bloc_name')"
                                   :remote-method="(search) => appEntrySearchList(search, 'bloc_name')">
                            <p class="option-select">
                                <el-button type="text"
                                           @click="() => handleSelectAll(bloc_name_DataList, 'bloc_name', 'all')">全选</el-button>
                                <el-button type="text"
                                           @click="() => handleSelectAll(bloc_name_DataList, 'bloc_name', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option v-for="item in bloc_name_DataList" :key="item.value" :label="item.label"
                                       :value="item.value" />
                        </ESelect>
                        <template #append>
                            <i class="el-icon-document-copy" />
                        </template>
                        <template #appendOrther>
                            <div :style="{ color: 'red', display: 'inline-block' }">
                                <i class="el-icon-close" @click="handleDel('bloc_name')" />
                            </div>
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="project_id" v-if="getCustomFilterShow('project_id')">
                    <CustomInput label='项目名称' @append-click=" handleGenAppendClick('project_id', '输入或粘贴项目名称，每行一个')">
                        <el-select style="width:110px" v-model="formData.project_id_type" slot="prepend"
                            placeholder="请选择" class="customInput_prepend_select">
                            <el-option value="1" label="项目名称选择"></el-option>
                            <el-option value="2" label="项目名称搜索"></el-option>
                        </el-select>
                        <ESelect v-if="formData.project_id_type == '1'" v-model="formData.project_id" filterable
                            clearable placeholder="请输入项目名称搜索选择" multiple collapse-tags remote reserve-keyword
                            :loading="searchLoading" ref="project_id"
                            @visible-change="(val) => handleVisibleChange(val, 'project_id')"
                            :remote-method="(search) => appEntrySearchList(search, 'project_id')">
                            <p class="option-select">
                                <el-button type="text"
                                    @click="() => handleSelectAll(project_id_DataList, 'project_id', 'all')">全选</el-button>
                                <el-button type="text"
                                    @click="() => handleSelectAll(project_id_DataList, 'project_id', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option v-for="item in project_id_DataList" :key="item.value" :label="item.label"
                                :value="item.value" />
                        </ESelect>
                        <el-input v-model="formData.project_name_search" placeholder="请输入项目名称搜索" clearable
                            style="width:180px" v-if="formData.project_id_type == '2'"></el-input>
                        <template #append v-if="formData.project_id_type == '1'">
                            <i class="el-icon-document-copy" />
                        </template>
                        <template #appendOrther>
                            <div :style="{ color: 'red', display: 'inline-block' }">
                                <i class="el-icon-close" @click="handleDel('project_id')" />
                            </div>
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="product" v-if="getCustomFilterShow('product')">
                    <CustomInput label="产品">
                        <ESelect v-model="formData.product" filterable clearable multiple collapse-tags remote reserve-keyword
                                 placeholder="搜索已关联产品" :loading="searchLoading"
                                 :remote-method="search => appEntrySearchList(search, 'product')">
                            <p class="option-select">
                                <el-button type="text" @click="handleSelectAll(product_DataList, 'product', 'all')">全选</el-button>
                                <el-button type="text" @click="handleSelectAll(product_DataList, 'product', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option v-for="item in product_DataList" :key="item.value" :value="item.value" :label="item.label" />
                        </ESelect>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="app_type" v-if="getCustomFilterShow('app_type')">
                    <CustomInput label='产品类型'>
                        <SelectAll :options="defaultOptions['app_type']" v-model="formData.app_type" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('app_type')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="package_type" v-if="getCustomFilterShow('package_type')">
                    <CustomInput label='包体类型'>
                        <SelectAll :options="defaultOptions['package_type']" v-model="formData.package_type" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('package_type')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="game_classify" v-if="getCustomFilterShow('game_classify')">
                    <CustomInput label='游戏分类'>
                        <SelectAll :options="defaultOptions['game_classify']" v-model="formData.game_classify" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('game_classify')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="plat_id" v-if="getCustomFilterShow('plat_id')">
                    <CustomInput label='媒体'>
                        <SelectAll :options="defaultOptions['plat']" v-model="formData.plat_id" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('plat_id')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="delivery_scene" v-if="getCustomFilterShow('delivery_scene')">
                    <CustomInput label='投放场景'>
                        <SelectAll :options="defaultOptions['delivery_scene']" v-model="formData.delivery_scene" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('delivery_scene')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="delivery_type" v-if="getCustomFilterShow('delivery_type')">
                    <CustomInput label='投放版位'>
                        <SelectAll :options="defaultOptions['delivery_type']" v-model="formData.delivery_type" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('delivery_type')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="material_uid" v-if="getCustomFilterShow('material_uid')">
                    <CustomInput label='制作人'>
                        <SelectAll :options="production_user_DataList" v-model="formData.material_uid" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('material_uid')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="material_group" v-if="getCustomFilterShow('material_group')">
                    <CustomInput label='制作部门'>
                        <SelectAll :options="material_group_DataList" v-model="formData.material_group" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('material_group')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="urgent_level" v-if="getCustomFilterShow('urgent_level')">
                    <CustomInput label='任务紧急程度'>
                        <SelectAll :options="defaultOptions['urgent_level']" v-model="formData.urgent_level" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('urgent_level')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="is_used" v-if="getCustomFilterShow('is_used')">
                    <CustomInput label='使用状态'>
                        <SelectAll :options="defaultOptions['is_used']" v-model="formData.is_used" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('is_used')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="production_status" v-if="getCustomFilterShow('production_status')">
                    <CustomInput label='制作状态'>
                        <SelectAll :options="defaultOptions['production_status']"
                                   v-model="formData.production_status" />
                        <template #append>
                            <!--                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('production_status')"/>-->
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="material_type" v-if="getCustomFilterShow('material_type')">
                    <CustomInput label='素材类型'>
                        <SelectAll :options="defaultOptions['material_type']" v-model="formData.material_type" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('material_type')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="material_id" v-if="getCustomFilterShow('material_id')">
                    <CustomInput label='素材名称' @append-click=" handleGenAppendClick('material_id', '输入或粘贴名称，每行一个')">
                        <el-select style="width:110px" v-model="formData.material_id_type" slot="prepend"
                            placeholder="请选择" class="customInput_prepend_select">
                            <el-option value="1" label="素材名称选择"></el-option>
                            <el-option value="2" label="素材名称搜索"></el-option>
                        </el-select>
                        <ESelect v-if="formData.material_id_type == '1'" v-model="formData.material_id" filterable placeholder="请输入素材名称搜索选择" multiple
                            collapse-tags remote reserve-keyword :loading="searchLoading" ref="material_id"
                            @visible-change="(val) => handleVisibleChange(val, 'material_id')"
                            :remote-method="(search) => appEntrySearchList(search, 'material_name')" style="width:220px">
                            <p class="option-select">
                                <el-button type="text"
                                    @click="() => handleSelectAll(material_name_DataList, 'material_id', 'all')">全选</el-button>
                                <el-button type="text"
                                    @click="() => handleSelectAll(material_name_DataList, 'material_id', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option v-for="item in material_name_DataList" :key="item.value" :label="item.label"
                                :value="item.value" />
                        </ESelect>
                        <el-input v-model="formData.material_name_search" placeholder="请输入素材名称搜索" clearable
                            style="width:180px" v-if="formData.material_id_type == '2'"></el-input>
                        <template #appendOrther>
                            <div :style="{ color: 'red', display: 'inline-block' }">
                                <i class="el-icon-close" @click="handleDel('material_id')" />
                            </div>
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="material_md5" v-if="getCustomFilterShow('material_md5')">
                    <CustomInput label='素材MD5' @append-click=" handleGenAppendClick('material_md5', '输入或粘贴内容，每行一个')">
                        <ESelect v-model="formData.material_md5" filterable placeholder="请输入素材MD5搜索选择" multiple
                                   collapse-tags remote reserve-keyword :loading="searchLoading" ref="material_md5"
                                   @visible-change="(val) => handleVisibleChange(val, 'material_md5')"
                                   :remote-method="(search) => appEntrySearchList(search, 'material_md5')">
                            <p class="option-select">
                                <el-button type="text"
                                           @click="() => handleSelectAll(material_md5_DataList, 'material_md5', 'all')">全选</el-button>
                                <el-button type="text"
                                           @click="() => handleSelectAll(material_md5_DataList, 'material_md5', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option v-for="item in material_md5_DataList" :key="item.value" :label="item.label"
                                       :value="item.value" />
                        </ESelect>
                        <template #appendOrther>
                            <div :style="{ color: 'red', display: 'inline-block' }">
                                <i class="el-icon-close" @click="handleDel('material_md5')" />
                            </div>
                        </template>
                    </CustomInput>
                </el-form-item>

                <el-form-item prop="create_uid" v-if="getCustomFilterShow('create_uid')">
                    <CustomInput label='创建人'>
                        <SelectAll :options="create_user_DataList" v-model="formData.create_uid" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('create_uid')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="range_time" v-if="getCustomFilterShow('range_time')">
                    <CustomInput label='创建日期'>
                        <el-date-picker v-model="formData.range_time" type="daterange" range-separator="至"
                                        start-placeholder="开始日期" prefix-icon="" clearable value-format="yyyy-MM-dd"
                                        end-placeholder="结束日期" :picker-options="basePickerOptions">
                        </el-date-picker>
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('range_time')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="expected_end_time" v-if="getCustomFilterShow('expected_end_time')">
                    <CustomInput label='期望完成日期'>
                        <el-date-picker v-model="formData.expected_end_time" type="daterange" range-separator="至"
                            start-placeholder="开始日期" prefix-icon="" clearable value-format="yyyy-MM-dd"
                            end-placeholder="结束日期" :picker-options="basePickerOptions">
                        </el-date-picker>
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }"
                                @click="handleDel('expected_end_time')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="material_end_time" v-if="getCustomFilterShow('material_end_time')">
                    <CustomInput label='制作完成日期'>
                        <el-date-picker v-model="formData.material_end_time" type="daterange" range-separator="至"
                            start-placeholder="开始日期" prefix-icon="" clearable value-format="yyyy-MM-dd"
                            end-placeholder="结束日期" :picker-options="basePickerOptions">
                        </el-date-picker>
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }"
                                @click="handleDel('material_end_time')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="is_new" v-if="getCustomFilterShow('is_new')">
                    <CustomInput label='是否新品'>
                        <SelectAll :options="defaultOptions['is_new']" :multiple="false" v-model="formData.is_new" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('is_new')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="project_tag11" v-if="getCustomFilterShow('project_tag11')">
                    <CustomInput label='游戏类型'>
                        <SelectAll :options="defaultOptions['project_tag11']" v-model="formData.project_tag11" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('project_tag11')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="project_tag12" v-if="getCustomFilterShow('project_tag12')">
                    <CustomInput label='游戏题材'>
                        <SelectAll :options="defaultOptions['project_tag12']" v-model="formData.project_tag12" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('project_tag12')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="work_order_label" v-if="getCustomFilterShow('work_order_label')">
                    <CustomInput label='工单标签'>
                        <SelectAll :options="work_order_label_DataList" v-model="formData.work_order_label" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('work_order_label')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="user_group" v-if="getCustomFilterShow('user_group')">
                    <CustomInput label='创建人部门'>
                        <SelectAll :options="user_group_DataList" v-model="formData.user_group" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('user_group')" />
                        </template>
                    </CustomInput>
                </el-form-item>
                <el-form-item prop="material_label" v-if="getCustomFilterShow('material_label')">
                    <CustomInput label='素材分类标签'>
                        <SelectAll :options="material_label_DataList" v-model="formData.material_label" />
                        <template #append>
                            <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('material_label')" />
                        </template>
                    </CustomInput>
                </el-form-item>

                <el-form-item>
                    <FilterPopSelect :list="listMap" :value="customFilter" @change="changeFilter" />
                </el-form-item>
            </el-form>
            <div class="opts">
                <el-button type="primary" size="mini"
                    v-matomo="{ behaviorCategory: '素材工单(工单管理)', event: '点击', name: '筛选(查询)' }"
                    @click="handleOnSubmit(false)">查询</el-button>
                <el-button size="mini" v-matomo="{ behaviorCategory: '素材工单(工单管理)', event: '点击', name: '筛选(清空筛选)' }"
                    @click="resetForm('formInline')">清空筛选</el-button>
            </div>
        </div>
    </div>
</template>

<script>

import CustomInput from '@/components/CustomInput'
import FilterPopSelect from '../../../components/filterPopSelect';
import SelectAll from '@/components/SelectAll';
import { batchSelectModal } from "@/components/modal"
import APICOMMON from "@/api/dataCenter/appKpi.js"
import API from "@/api/workOrder/material.js"
import MsgHeader from "./msg.vue";
export default {
    name: 'materialPage_query',
    props: {
        reload: {
            type: String,
            default: ''
        },
        tags: {
            type: String,
            default: '1'  //1:待指派  2:制作中 3 被驳回 等
        }
    },
    components: {
        MsgHeader,
        CustomInput,
        FilterPopSelect,
        SelectAll
    },
    data() {
        return {
            genTypeList: [{ label: '推广名称', value: 'subproject_name' }],
            basePickerOptions: {
                firstDayOfWeek: 1,
                shortcuts: [
                    {
                        text: '最近7天',
                        onClick(picker) {
                            const date = new Date();
                            let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 7);
                            let endDate = new Date(date.getTime());
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '上周',
                        onClick(picker) {
                            // 上周：自然周，周一到周日
                            let date = new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 7);
                            let weekDay = date.getDay();
                            let startDate = new Date(date.getTime() - 1000 * 60 * 60 * 24 * (weekDay === 0 ? 6 : weekDay - 1));
                            let endDate = new Date(startDate.getTime() + 1000 * 60 * 60 * 24 * 6);
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '本月',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth() + 1;
                            let day = date.getDate();
                            let startDate = year + '-' + month + '-1';
                            let endDate = year + '-' + month + '-' + day;
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '上月',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth();
                            let startDate = new Date(year + '-' + month + '-01');
                            let endDate = new Date(new Date(year + '-' + (month + 1) + '-01').getTime() - 1000 * 60 * 60 * 24);
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '本季度',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth() + 1;
                            let day = date.getDate();
                            let startDate = '';
                            if ([1, 2, 3].includes(month)) {
                                startDate = year + '-01-01';
                            } else if ([4, 5, 6].includes(month)) {
                                startDate = year + '-04-01';
                            } else if ([7, 8, 9].includes(month)) {
                                startDate = year + '-07-01';
                            } else if ([10, 11, 12].includes(month)) {
                                startDate = year + '-10-01';
                            }
                            let endDate = year + '-' + month + '-' + day;
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '上季度',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth() + 1;

                            let startDate = '';
                            let endDate = '';
                            if ([1, 2, 3].includes(month)) {
                                startDate = (year - 1) + '-10-01';
                                endDate = (year - 1) + '-12-31';
                            } else if ([4, 5, 6].includes(month)) {
                                startDate = year + '-01-01';
                                endDate = year + '-03-31';
                            } else if ([7, 8, 9].includes(month)) {
                                startDate = year + '-04-01';
                                endDate = year + '-06-30';
                            } else if ([10, 11, 12].includes(month)) {
                                startDate = year + '-07-01';
                                endDate = year + '-09-30';
                            }
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '今年',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let startDate = year + '-01-01';
                            let endDate = year + '-12-31';
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '去年',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear() - 1;
                            let startDate = year + '-01-01';
                            let endDate = year + '-12-31';
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    }
                ]
            },
            defaultOptions: {
                app_type: [],
                game_classify: [],
                is_used: [],
                material_type: [],
                plat: [],
                production_status: [],
                urgent_level: [],
                package_type:[],
                delivery_scene:[],
                delivery_type:[],
                is_new: [],
                project_tag11: [],
                project_tag12: [],
                work_order_label: [],
                user_group: [],
                material_label: [],
            },
            dictData: {},
            work_order_DataList: [],
            project_id_DataList: [],
            material_name_DataList: [],
            material_group_DataList: [], // 制作部门
            create_user_DataList: [], // 创建人
            production_user_DataList: [], // 制作人
            company_name_DataList:[],
            bloc_name_DataList:[],
            material_md5_DataList:[],
            work_order_label_DataList:[],
            user_group_DataList:[],
            material_label_DataList:[],
            product_DataList:[],
            formData: {
                work_order_type: '1',
                work_order_search: '',//工单搜索
                work_order: [],//工单
                project_id_type: '1',
                project_name_search: '',//项目名称搜索
                project_id: [], //项目
                app_type: [],//产品类型
                product: [],
                game_classify: [],//游戏分类
                plat_id: [],//媒体
                material_id_type: '1',
                material_name_search: '',//素材名称搜索
                material_id: [],//素材名称
                material_type: [],//素材类型
                urgent_level: [], //任务紧急程度
                is_used: [], //使用状态
                production_status: [],//制作状态
                material_group: [],//制作部门
                material_uid: [],//制作人
                create_uid: [], //创建人
                expected_end_time: [],//期望完成日期
                material_end_time: [],//制作完成时间
                range_time: [],//创建时间
                company_name:[],
                bloc_name:[],
                material_md5: [],//素材名称
                delivery_scene:[],
                delivery_type:[],
                is_new: '',
                project_tag11: [],
                project_tag12: [],
                work_order_label: [],
                user_group: [],
                material_label: [],
            },
            msg_type: '2',
            listMap: [
                {
                    name: "work_order",
                    label: "工单名称",
                },
                {
                    name: "company_name",
                    label: "客户名称",
                },
                {
                    name: "bloc_name",
                    label: "集团名称",
                },
                {
                    name: "project_id",
                    label: "项目名称",
                },
                {
                    name: "app_type",
                    label: "产品类型",
                },
                {
                    name: "product",
                    label: "产品",
                },
                {
                    name: "package_type",
                    label: "包体类型",
                },
                {
                    name: "game_classify",
                    label: "游戏分类",
                },
                {
                    name: "plat_id",
                    label: "媒体",
                },
                {
                    name: "delivery_scene",
                    label: "投放场景",
                },
                {
                    name: "delivery_type",
                    label: "投放版位",
                },
                {
                    name: "material_uid",
                    label: "制作人",
                },
                {
                    name: "material_group",
                    label: "制作部门",
                },
                {
                    name: "urgent_level",
                    label: "任务紧急程度",
                },
                {
                    name: "is_used",
                    label: "使用状态",
                },
                {
                    name: "production_status",
                    label: "制作状态",
                    default_check: true,
                },
                {
                    name: "material_type",
                    label: "素材类型",
                },
                {
                    name: "material_id",
                    label: "素材名称",
                },
                {
                    name: "material_md5",
                    label: "素材MD5",
                },
                {
                    name: "create_uid",
                    label: "创建人",
                },
                {
                    name: "range_time",
                    label: "创建日期",
                },
                {
                    name: "expected_end_time",
                    label: "期望完成日期",
                },
                {
                    name: "material_end_time",
                    label: "制作完成日期",
                },
                {
                    name: "is_new",
                    label: "是否新品",
                },
                {
                    name: "project_tag11",
                    label: "游戏类型",
                },
                {
                    name: "project_tag12",
                    label: "游戏题材",
                },
                {
                    name: "work_order_label",
                    label: "工单标签",
                },
                {
                    name: "user_group",
                    label: "创建人部门",
                },
                {
                    name: "material_label",
                    label: "素材分类标签",
                },
            ],
            customFilter: [], // ['work_order', 'project_id', 'app_type', 'game_classify', 'plat_id', 'material_type', 'urgent_level', 'is_used', 'production_status'],
            searchLoading: false,
            loading: false,
        }
    },
    watch: {
        'reload': {
            handler(n, o) {
                if (n === 'add' || n === 'copy') {
                    this.resetForm()
                    // setTimeout(()=>{
                    //     this.handleOnSubmit(false)
                    // },100)
                } else if (n === 'edit') {
                    this.handleOnSubmit(false)
                }
            },
            deep: true
        },
        'tags': {
            handler(n, o) {
                this.material_group_DataList = []
                this.formData.material_group = []
                this.fetGetGroupList()

                let params = {}
                for (let key in this.formData) {
                    params[key] = this.formData[key]
                }
                let res_expected_end_time = this.formData.expected_end_time ? this.formData.expected_end_time.join('/') : ''; //时间的格式处理
                let res_material_end_time = this.formData.material_end_time ? this.formData.material_end_time.join('/') : ''; //时间的格式处理
                let res_range_time = this.formData.range_time ? this.formData.range_time.join('/') : ''; //时间的格式处理
                params['expected_end_time'] = res_expected_end_time
                params['material_end_time'] = res_material_end_time
                params['range_time'] = res_range_time

                params['msg_type'] = this.msg_type

                this.$emit('updata', params)
            },
            immediate: true
        },
        'formData.project_id_type': {
            handler(n, o) {
                if (n == '1') {
                    this.formData.project_name_search = ''
                } else {
                    this.formData.project_id = []
                }
            },
            deep: true,
            immediate: true
        },
        'formData.work_order_type': {
            handler(n, o) {
                if (n == '1') {
                    this.formData.work_order_search = ''
                } else {
                    this.formData.work_order = []
                }
            },
            deep: true,
            immediate: true
        },
        'formData.material_id_type': {
            handler(n, o) {
                if (n == '1') {
                    this.formData.material_name_search = ''
                } else {
                    this.formData.material_id = []
                }
            },
            deep: true,
            immediate: true
        },
    },
    created() {
        // const today = dayjs();
        // const thirtyDaysAgo = today.subtract(30, 'day');
        // this.formData.range_time = [thirtyDaysAgo.format('YYYY-MM-DD'), today.format('YYYY-MM-DD')]
    },
    mounted() {
        this.fetchGetCustomFilter()
        this.handleOnSubmit(false)
    },
    methods: {
        fetchGetCustomFilter() {
            this.loading = true
            APICOMMON.getCustomFilter({ field_type: 'work_order_filter' }).then(res => {
                console.log(res)
                this.loading = false
                if (res.data && res.data.length > 0) {
                    this.customFilter = res.data
                }
                this.fetGetSearchList()
                this.fetchGetSearchOther()
            }, err => {
                this.loading = false
                this.$message.error(err.info)
            }).finally(() => {
                // this.handleOnSubmit()
            })
        },
        fetchSetCustomFilter(values) {
            let res_filter = this.listMap.filter(item => values.includes(item.name))
            APICOMMON.setCustomFilter({ field_type: 'work_order_filter', filters: res_filter }).then(res => {
                this.$message.success('成功')
            })
        },
        //部分 下拉枚举值
        fetGetSearchList() {
            API.getSearchWorkOrderOptions({ type: 'work_order' }).then(res => {
                // this.$message.success('成功')
                this.defaultOptions = res.data
            }, err => {
                this.$message.error(err.info)
            })
        },
        //部分 远程搜索下拉枚举值
        fetchGetSearchOther() {
            let forArray = ['create_user', 'production_user', 'work_order_label', 'user_group','material_label', 'product' ]
            forArray.forEach((item) => {
                API.postSearchWorkOrderMethodOptions({ search: '', batch_search: '', search_type: item }).then(res => {
                    this[`${item}_DataList`] = res.data.list.map(v => {
                        return {
                            ...v,
                            value: v.id,
                            label: v.name
                        }
                    })
                }, err => {
                    this.$message.error(err.info)
                })
            })
        },
        // 单独处理 制作人部门
        fetGetGroupList() {
            API.postSearchWorkOrderMethodOptions({ search: '', batch_search: '', search_type: 'material_group', order_status: this.tags }).then(res => {
                this.material_group_DataList = res.data.list.map(v => {
                    return {
                        ...v,
                        value: v.id,
                        label: v.name
                    }
                })
            }, err => {
                this.$message.error(err.info)
            })
        },
        changeFilter(values) {
            this.customFilter = values
            this.resetData(this.customFilter)
        },
        // 删除
        handleDel(name) {
            let del_index = this.customFilter.findIndex(item => item == name);
            this.customFilter.splice(del_index, 1)
            console.log('this.customFilter', this.customFilter, del_index)
            this.resetData(this.customFilter)
        },
        // 重置form变量
        resetData(values) {
            if (Array.isArray(values)) {
                for (let key in this.formData) {
                    if (!values.includes(key)) {
                        this.formData[key] = null;
                    }
                }
                this.formData.work_order_type = '1'
                this.formData.project_id_type = '1'
                this.formData.material_id_type = '1'
            }
            this.fetchSetCustomFilter(values)
        },
        // 表单项 显示与隐藏
        getCustomFilterShow(name) {
            return this.customFilter.includes(name)
        },
        // 下拉检索
        async appEntrySearchList(search, type, p = {}, cb) {
            try {
                const params = {
                    search_type: type,
                    search,
                    ...p
                };
                this.searchLoading = true
                const { data } = await API.postSearchWorkOrderMethodOptions(params);
                const list = data.list;
                const errList = data.err_list;
                if (params.batch_search) {
                    cb(errList, () => {
                        const ids = list.map(v => v.id)
                        this[`${type}_DataList`] = [
                            ...this[`${type}_DataList`].filter(v => this.formData[type].includes(v.value) && !ids.includes(v.value)),
                            ...list.map(v => {
                                return {
                                    ...v,
                                    value: v.id,
                                    label: v.name
                                }
                            })
                        ]
                        this.formData[type] = [...new Set([...this.formData[type], ...ids])];
                    })
                } else {
                    this[`${type}_DataList`] = list.map(v => {
                        return {
                            ...v,
                            value: v.id,
                            label: v.name
                        }
                    })
                }
            } catch (error) {
                this.$message.warning(error.info)
            } finally {
                this.searchLoading = false
            }
        },

        handleGenAppendClick(type, placeholder) {
            const onSubmit = (data, callback) => {
                this.appEntrySearchList(
                    '',
                    type,
                    {
                        batch_search: data,
                    },
                    (errs, cb) => {
                        callback();
                        if (errs.length) {
                            delErrList({
                                tip: '未找到以下数据信息，请核实，是否需要剔除未找到的?',
                                list: errs,
                                onOk: () => {
                                    cb();
                                    vm.close();
                                }
                            })
                        } else {
                            cb();
                            vm.close();
                        }
                    }
                )
            }
            const { vm, delErrList } = batchSelectModal({
                title: type == 'work_order' ? '批量筛选工单' : type == 'project_id' ? '批量筛选项目' : '批量添加',
                props: {
                    tip: placeholder ? placeholder : '输入或粘贴名称或ID，每行一个',
                    hasLoading: true
                },
                cbs: {
                    onSubmit
                }
            })
        },
        handleVisibleChange(visible, type) {
            if (visible) {
                const options = this.$refs[type].selected || [];
                const listData = options.map(v => {
                    return v.$options.propsData
                });
                this.$set(this, `${type}_DataList`, listData)
            }
        },
        handleSelectAll(list, type, selectType) {
            if (selectType === 'all') {
                const data = [...(this.formData[type] || [])];
                data.push(...list.map(v => v.value));
                // 去重 赋值
                let resule = [...new Set(data)]
                // if(resule.length >= 3000) {
                //     this.formData[`${type}_search`] = list.map(v => v.value)
                // }
                // else{
                //     this.formData[type] = resule
                // }
                this.formData[type] = resule
            } else {
                let optionList_ids = this[`${type}_DataList`].map(item => item.value)
                let channel_ids = this.formData[type].filter(item => !optionList_ids.includes(item))
                this.formData[type] = [...channel_ids]
            }
        },
        handleOnSubmit(status) {
            let params = {}
            for (let key in this.formData) {
                // 处理投放场景和投放版位
                if(key=='delivery_scene'||key=='delivery_type'){
                    let dataArr = this.formData[key]||[];
                    let list = [];
                    dataArr.forEach(item=>{
                        list = list.concat(item.split(','))
                    })
                    params[key] = list;
                }else {
                    params[key] = this.formData[key]
                }
            }
            let res_expected_end_time = this.formData.expected_end_time ? this.formData.expected_end_time.join('/') : ''; //时间的格式处理
            let res_material_end_time = this.formData.material_end_time ? this.formData.material_end_time.join('/') : ''; //时间的格式处理
            let res_range_time = this.formData.range_time ? this.formData.range_time.join('/') : ''; //时间的格式处理
            params['expected_end_time'] = res_expected_end_time
            params['material_end_time'] = res_material_end_time
            params['range_time'] = res_range_time

            params['msg_type'] = this.msg_type
            // this.$router.replace({name:'work_order_material', query:{}})
            this.$refs.msg.fetchMsg()
            this.$emit('query-click', { params: params, status: status, reload: this.reload })
        },
        //清空
        resetForm(action) {
            this.$refs['formInline'].resetFields();
            this.formData.work_order_type = '1'
            this.formData.project_id_type = '1'
            this.formData.material_id_type = '1'
            this.formData.work_order = []
            this.formData.project_id = []
            this.formData.material_id = []
            this.formData.app_type = []
            this.formData.product = []
            this.formData.game_classify = []
            this.formData.plat_id = []
            this.formData.material_type = []
            this.formData.urgent_level = []
            this.formData.is_used = []
            this.formData.production_status = []
            this.formData.material_group = []
            this.formData.material_uid = []
            this.formData.create_uid = []
            this.formData.expected_end_time = []
            this.formData.material_end_time = []
            this.formData.range_time = []
            this.formData.company_name = []
            this.formData.bloc_name = []
            this.formData.material_md5 = []
            this.formData.package_type = []
            this.formData.delivery_scene = []
            this.formData.delivery_type = []
            this.formData.is_new = []
            this.formData.project_tag11 = []
            this.formData.project_tag12 = []
            this.formData.work_order_label = []
            this.formData.user_group = []
            this.formData.material_label = []

            // this.$router.replace({name:'work_order_material', query:{}})
            this.$nextTick(() => {
                this.handleOnSubmit(false)
            })

        },
        // 消息的点击跳转
        handleMsg(type) {
            this.$router.replace({
                name: 'work_order_material',
                query: {
                    topage: 'MaterialPage',
                    tagsActive: type,
                },
                params: {
                    menuReload: 1
                }
            });

            this.$refs['formInline'].resetFields();
            this.msg_type = type
            if (type == 2) {
                this.formData.production_status = [2]
            }
            this.formData.range_time = []
            // this.formData.production_status = 2
            this.$nextTick(() => {
                this.handleOnSubmit(true)
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.opts {
    border-top: 1px solid #DCDFE6;
    padding-top: 10px;
}

.form-box {
    background: #ffffff;
    padding: 20px 10px;
    border-radius: 4px;

    &::v-deep {
        .el-form-item {
            margin-bottom: 10px;
        }

        .el-select__input.is-mini {
            font-size: 12px;
        }
    }
}

.table-context {
    background-color: #fff;
    margin-top: 12px;
    border-radius: 4px;
    padding-top: 12px;
}
</style>
